import "./miniapp-aside-.js";
import "./miniapp-icon.png";
import "../aside/aside.njk";
import "./bottom-cover.njk";
require("./miniapp-aside.less");